import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import ar from './locales/ar.json';
import br from './locales/br.json';
import da from './locales/da.json';
import de from './locales/de.json';
import enGB from './locales/en-GB.json';
import enUS from './locales/en-us.json';
import es from './locales/es.json';
import frCA from './locales/fr-ca.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import latAM from './locales/lat-am.json';
import nb from './locales/nb.json';
import nl from './locales/nl.json';
import pt from './locales/pt.json';
import ro from './locales/ro.json';
import tr from './locales/tr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['path'],
      caches: [],
    },
    resources: {
      'en-GB': {
        translations: enGB,
      },
      'en-IE': {
        translations: enGB,
      },
      'en-CA': {
        translations: enGB,
      },
      'en-us': {
        translations: enUS,
      },
      'en-AE': {
        translations: enGB,
      },
      'en-AU': {
        translations: enGB,
      },
      es: {
        translations: es,
      },
      pt: {
        translations: pt,
      },
      fr: {
        translations: fr,
      },
      ro: {
        translations: ro,
      },
      nl: {
        translations: nl,
      },
      tr: {
        translations: tr,
      },
      de: {
        translations: de,
      },
      nb: {
        translations: nb,
      },
      it: {
        translations: it,
      },
      'fr-CA': {
        translations: frCA,
      },
      ar: {
        translations: ar,
      },
      'ar-AE': {
        translations: ar,
      },
      'pt-BR': {
        translations: br,
      },
      'es-149': {
        translations: latAM,
      },
      'da': {
        translations: da,
      },
    },
    fallbackLng: 'en-GB',
    debug: true,
    ns: ['translations'],
    defaultNS: 'translations',
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
